<template>
  <div v-if="studentCredit.student && studentCredit.student.id">
    <StudentProfileHeader class="mb-6" :student="studentCredit.student" />
    <CreditUsageTable />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import StudentProfileHeader from '../student/components/StudentProfileHeader.vue'
import CreditUsageTable from '../../modules/studentCredit/CreditUsageTable.vue'
export default {
  components: { StudentProfileHeader, CreditUsageTable },
  computed: {
    ...mapState({
      studentCredit(state) {
        return state['studentCredit'].studentCredit
      }
    })
  },
  async created() {
    this.resetStudentCredit()
    const id = this.$route.params.id
    if (id) {
      const res = await this.fetchOne(id)
      if (res) {
        await this.fetchCreditUsage({ student: res.student.id, _start: 0, _limit: 10 })
        await this.countItems({ student: res.student.id })
      }
    }
  },
  methods: {
    ...mapActions({
      fetchOne: 'studentCredit/fetchOne',
      fetchCreditUsage: 'studentCreditUsage/fetch',
      countItems: 'studentCreditUsage/countItems',
      resetStudentCredit: 'studentCredit/resetStudentCredit'
    })
  }
}
</script>

<style lang="scss" scoped></style>
